var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CoolLightBox',_vm._b({attrs:{"closeOnClickOutsideMobile":true,"enableScrollLock":false},on:{"on-change":function($event){return _vm.$emit('on-change', $event)},"on-open":function($event){return _vm.onOpen($event)},"close":function($event){return _vm.onClose($event)}}},'CoolLightBox',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }